import { useAppConfig } from "hooks/queries";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { useEffect, useState } from "react";
import { AuthProvider, TAuthConfig } from "react-oauth2-code-pkce";
import { setAuthContextConfigured } from "./vendorUserSlice";
import { setAppConfig } from "store/appConfigSlice";
import { selectRfi } from "store/rfiSlice";

const makeId = (length: number) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

type Props = {
  children?: JSX.Element | JSX.Element[];
};

const VendorAuthWrapper: React.FC<Props> = ({ children }) => {
  // Hooks
  const dispatch = useAppDispatch();
  const {
    isLoading: appConfigIsLoading,
    data: appConfig,
    refetch,
  } = useAppConfig();

  // State
  const [vendorAuthConfig, setVendorAuthConfig] = useState<TAuthConfig | null>(
    null
  );

  // Effects
  useEffect(() => {
    if (appConfig) {
      dispatch(setAppConfig(appConfig));
    }

    if (
      appConfig === null ||
      appConfig?.loginGov === null ||
      typeof appConfig === "undefined"
    )
      return;

    var { acr_values, logoutEndpoint, ...rest } = appConfig.loginGov;
    var newLogout =
      logoutEndpoint +
      window.location.origin +
      "&state=abcdefghijklmnopabcdefghijklmnop";

    setVendorAuthConfig({
      ...rest,
      logoutEndpoint: newLogout,
      // Example to redirect back to original path after login has completed
      preLogin: () =>
        localStorage.setItem("preLoginPath", window.location.pathname),
      //postLogin: () => window.location.replace(localStorage.getItem('preLoginPath') || ''),
      redirectUri: window.location.origin + "/login/callback",
      decodeToken: false,
      autoLogin: false,
      storage: "session",
      extraAuthParameters: {
        acr_values: acr_values,
        state: makeId(22),
        nonce: makeId(22),
      },
      onRefreshTokenExpire: () => {
        //   console.log(
        //   `${new Date()
        //     .toISOString()
        //     .split(".")[0]
        //     .replace(/[^\d]/gi, "")} - onRefreshTokenExpire`
        // );
      },
    });
  }, [appConfig]);

  // Render
  if (appConfigIsLoading || vendorAuthConfig === null) {
    return <>{children}</>;
  }

  return <AuthWrapper authConfig={vendorAuthConfig}>{children}</AuthWrapper>;
};

interface AuthWrapperProps {
  authConfig: TAuthConfig;
  children?: JSX.Element | JSX.Element[];
}
/** Used to detect when AuthProvider is rendered so we can set isAuthContextConfigured in redux only after AuthProvider has rendered */
const AuthWrapper = ({ authConfig, children }: AuthWrapperProps) => {
  // Hooks
  const dispatch = useAppDispatch();
  // set isAuthContextConfigured in redux after AuthProvider is guaranteed to have rendered

  // Effects
  useEffect(() => {
    dispatch(setAuthContextConfigured(true));
  }, []);

  // Render
  return <AuthProvider authConfig={authConfig}>{children}</AuthProvider>;
};

export default VendorAuthWrapper;
